import { Pagination } from "@graffer-inc/console-design-kit";
import React from "react";

import type {
  Address,
  Paging,
  Place,
} from "../../../../application/domain/proc-management";
import { useAuthContextV2 } from "../../../../auth-state";

type Props = {
  places: Place[];
  orgId: string;
  paging: Paging;
  onRowClick: (props: { orgId: string; placeId: string }) => void;
  onPageClick: (props: { orgId: string; page: number }) => void;
};

export const PlacesTable: React.FC<Props> = ({
  places,
  orgId,
  paging,
  onRowClick,
  onPageClick,
}) => {
  const { auth } = useAuthContextV2();
  return (
    <div className="table-container">
      <table className="table is-fullwidth">
        <thead>
          <tr>
            <th>場所ID</th>
            <th>名称</th>
            <th>住所</th>
          </tr>
        </thead>
        <tbody>
          {places.map((place) => (
            <tr
              key={place.id}
              className="c-tr-selectable c-tr-has-tag"
              onClick={() => {
                if (auth.hasPermissions("proc_management.places.read")) {
                  onRowClick({
                    orgId,
                    placeId: place.id,
                  });
                }
              }}
            >
              <td>{place.id}</td>
              <td>{place.name}</td>
              <td>{addressStr(place.address)}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <div style={{ marginTop: "16px" }}>
        <Pagination
          onPageClick={(page) => {
            onPageClick({ orgId, page });
          }}
          currentPage={paging.current}
          lastPage={paging.last}
        />
      </div>
    </div>
  );
};

const addressStr = (address?: Address): string => {
  if (address) {
    const { address1, address2, address3 } = address;
    return `${address1}${address2}${address3 ?? ""}`;
  }
  return "未入力";
};

export default PlacesTable;
